import type { JobSubcategoryKey } from "@/domains/freelance/taxonomy/types";
import {
  type OfferSubcategoryTaxonomy,
  visibleSubcategories,
} from "@/domains/job-offer/ai/refine/utils/offer-subcategories";
import type { JobCategory } from "@/domains/job-offer/create/constants";

/**
 * The subcategories ("ambiti") a job offer card or detail shows, in the order
 * received. Read-only: it never writes back. `null`, `undefined` or `[]` show
 * nothing (not declared, or the whole category). Otherwise the keys go through
 * `visibleSubcategories`, which drops unknown keys and keys of another category
 * once the taxonomy is ready. `taxonomy` is optional; the default store is used
 * when omitted.
 */
export function shownOfferSubcategories(
  category: JobCategory | null | undefined,
  keys: readonly JobSubcategoryKey[] | null | undefined,
  taxonomy?: OfferSubcategoryTaxonomy,
): JobSubcategoryKey[] {
  if (!keys || keys.length === 0) return [];
  const visible = visibleSubcategories(
    category,
    { kind: "chosen", keys: [...keys] },
    taxonomy,
  );
  return visible.kind === "chosen" ? visible.keys : [];
}
